import { render, staticRenderFns } from "./singleChoice.vue?vue&type=template&id=00163b94&scoped=true"
import script from "./singleChoice.vue?vue&type=script&lang=ts"
export * from "./singleChoice.vue?vue&type=script&lang=ts"
import style0 from "./singleChoice.vue?vue&type=style&index=0&id=00163b94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00163b94",
  null
  
)

export default component.exports